export const DefaultHitSlop = {
  top: 12,
  left: 12,
  bottom: 12,
  right: 12,
};
